module.exports = __webpack_public_path__ + "media/images/sports_icons/008-climbing-1841cbbc03b128adfddff6eb0137d3ab.png";